import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel2";
import "./Video.css";
function Video() {
  const [video, setvideo] = useState([
    {
      id: 1,
      src: "https://www.youtube.com/embed/vdUvtzgVvfw?si=S8EC7V1lKkCGOJTd",
      title: "Software Training With Internship at MSTC",
      description: "Are you passionate about building a career in software development? Kickstart your journey with the Software Training Program at MSTC—a leading destination for comprehensive and hands-on learning experiences.",
    },
    {
      id: 2,
      src: "https://www.youtube.com/embed/9CHkno4qLP0?si=yybX81O2oPgQpesD",
      title: "Industrial Visit at Technopark by MSTC",
      description:"Embark on an enlightening journey to Technopark with MSTC—an Industrial Visit that promises to immerse participants in the latest advancements and innovations within the vibrant technology ecosystem.",

    },
  ]);
  const options = {
    items: 1,
    startPosition: 0,
    nav: true,
    rewind: true,
    autoplay: true,
    loop:true,
  };

  return (
    <div className="video-div">
      <OwlCarousel options={options} navcontainer={".owl-nav"}>
        {video.map((a, index) => {
          return (
            <div key={index}>
              <div className="video-container">
                <div className="video-item-1">
                  <iframe
                    width="100%"
                    height="100%"
                    src={a.src}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="video-item-2">
                  <h2> {a.title}</h2>
                  <p>{a.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </OwlCarousel>
    </div>
  );
}

export default Video;
